import { render, staticRenderFns } from "./XPage.vue?vue&type=template&id=f9050e12"
import script from "./XPage.vue?vue&type=script&lang=js"
export * from "./XPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports